// extracted by mini-css-extract-plugin
export default {"pieces":"Pieces_pieces__DDmCj","subtext":"Pieces_subtext__3htTL","text":"Pieces_text__6m3j4"};